import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v32.12.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import { T as t } from "../index.js";

var ListenerManager = /*#__PURE__*/function () {
  function ListenerManager() {
    _classCallCheck(this, ListenerManager);

    this.listeners = [];
  }

  _createClass(ListenerManager, [{
    key: "add",
    value: function add(t) {
      this.listeners.push(t);
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      this.listeners.forEach(function (t) {
        t && t.remove && t.remove(), t = null;
      }), this.listeners = [];
    }
  }]);

  return ListenerManager;
}();

var e = {
  NORTH: 1,
  EAST: 2,
  SOUTH: 4,
  WEST: 8
};

var AutoPan = /*#__PURE__*/function () {
  function AutoPan(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, AutoPan);

    this.map = t, this.setInsets(e), this.listeners = new ListenerManager();
  }

  _createClass(AutoPan, [{
    key: "_checkMousePosition",
    value: function _checkMousePosition(s) {
      var _this = this;

      this._clearFlags();

      var i = s,
          a = t.autoPan.edgeTolerance,
          n = t.autoPan.edgeToleranceFast;
      this.insets.some(function (t) {
        var e = t.width,
            s = t.height;
        return (null != t.left || null != t.right || null != t.top || null != t.bottom) && (null == t.left || t.left <= i.x && i.x <= t.left + e) && (null == t.right || _this.map.width - t.right - e <= i.x && i.x <= _this.map.width - t.right) && (null == t.top || t.top <= i.y && i.y <= t.top + s) && (null == t.bottom || _this.map.height - t.bottom - s <= i.y && i.y <= _this.map.height - t.bottom);
      }) || (i.y <= a && (this._panDirection |= e.NORTH), i.x >= this.map.width - a && (this._panDirection |= e.EAST), i.y >= this.map.height - a && (this._panDirection |= e.SOUTH), i.x <= a && (this._panDirection |= e.WEST), this._isFast = i.y <= n || i.x >= this.map.width - n || i.y >= this.map.height - n || i.x <= n, this.insets.forEach(function (t) {
        var s = t.width,
            o = t.height,
            h = _this.map.height - t.bottom,
            r = _this.map.height - t.bottom - o,
            l = t.left + s,
            p = _this.map.width - t.right,
            c = _this.map.width - t.right - s,
            m = t.top + o;
        console.assert(null == t.top || null == t.bottom), null != t.left && ((null == t.top || t.top <= i.y && i.y <= m + a) && (null == t.bottom || r - a <= i.y && i.y <= h) && l <= i.x && i.x <= l + a && (_this._panDirection |= e.WEST, i.x <= l + n && (_this._isFast = !0)), null != t.top && t.left <= i.x && i.x <= l + a && m <= i.y && i.y <= m + a && (_this._panDirection |= e.NORTH, i.y <= m + n && (_this._isFast = !0)), null != t.bottom && t.left <= i.x && i.x <= l + a && r - a <= i.y && i.y <= r && (_this._panDirection |= e.SOUTH, i.y >= r - n && (_this._isFast = !0))), null != t.right ? ((null == t.top || t.top <= i.y && i.y <= m + a) && (null == t.bottom || r - a <= i.y && i.y <= h) && c - a <= i.x && i.x <= c && (_this._panDirection |= e.EAST, i.x >= c - n && (_this._isFast = !0)), null != t.top && c - a <= i.x && i.x <= p && m <= i.y && i.y <= m + a && (_this._panDirection |= e.NORTH, i.y <= m + n && (_this._isFast = !0)), null != t.bottom && c - a <= i.x && i.x <= p && r - a <= i.y && i.y <= r && (_this._panDirection |= e.SOUTH, i.y >= r - n && (_this._isFast = !0))) : null != t.left && t.leftAndRight && ((null == t.top || t.top <= i.y && i.y <= m + a) && (null == t.bottom || r - a <= i.y && i.y <= h) && t.left - a <= i.x && i.x <= t.left && (_this._panDirection |= e.EAST, i.x >= t.left - n && (_this._isFast = !0)), null != t.top && t.left - a <= i.x && i.x <= l + a && m <= i.y && i.y <= m + a && (_this._panDirection |= e.NORTH, i.y <= m + n && (_this._isFast = !0)), null != t.bottom && t.left - a <= i.x && i.x <= l + a && r - a <= i.y && i.y <= r && (_this._panDirection |= e.SOUTH, i.y >= r - n && (_this._isFast = !0)));
      }));
    }
  }, {
    key: "_clearFlags",
    value: function _clearFlags() {
      this._isFast = !1, this._panDirection = 0;
    }
  }, {
    key: "_createAutoPanListeners",
    value: function _createAutoPanListeners() {
      var _this2 = this;

      this._removeAutoPanListeners();

      var _clearPanStripTimer = function _clearPanStripTimer() {
        _this2._clearFlags(), _this2._mouseOverPanStrip = !1, clearTimeout(_this2._setMouseOverPanStripTimer), _this2._setMouseOverPanStripTimer = null;
      },
          _setOverMap = function _setOverMap(e) {
        _this2._checkMousePosition(e), 0 === _this2._panDirection || _this2._setMouseOverPanStripTimer ? 0 === _this2._panDirection && _clearPanStripTimer() : _this2._setMouseOverPanStripTimer = setTimeout(function () {
          _this2._mouseOverPanStrip = !0;
        }, t.autoPan.startDelay);
      };

      this._timer = setInterval(function () {
        return _this2._interval();
      }, t.autoPan.panDuration), this.listeners.add(this.map.on("drag", function (t) {
        return _setOverMap(t);
      })), this.listeners.add(this.map.on("pointer-move", function (t) {
        return _setOverMap(t);
      })), this.listeners.add(this.map.on("pointer-leave", function () {
        return _clearPanStripTimer();
      }));
    }
  }, {
    key: "_getDeltas",
    value: function _getDeltas(s, i, a) {
      var n = (this._isFast ? t.autoPan.panPercentageFast : t.autoPan.panPercentage) / 100,
          o = s * n,
          h = (a ? -1 : 1) * i * n,
          r = {
        dx: 0,
        dy: 0
      };

      switch (this._panDirection) {
        case e.NORTH:
        case e.NORTH | e.EAST | e.WEST:
          r.dy += h;
          break;

        case e.NORTH | e.EAST:
          r.dx += o, r.dy += h;
          break;

        case e.EAST:
        case e.EAST | e.NORTH | e.SOUTH:
          r.dx += o;
          break;

        case e.SOUTH | e.EAST:
          r.dx += o, r.dy -= h;
          break;

        case e.SOUTH:
        case e.SOUTH | e.EAST | e.WEST:
          r.dy -= h;
          break;

        case e.SOUTH | e.WEST:
          r.dx -= o, r.dy -= h;
          break;

        case e.WEST:
        case e.WEST | e.NORTH | e.SOUTH:
          r.dx -= o;
          break;

        case e.NORTH | e.WEST:
          r.dx -= o, r.dy += h;
      }

      return r;
    }
  }, {
    key: "_interval",
    value: function _interval() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      if (!t && !this._mouseOverPanStrip) return;

      var e = this._getDeltas(this.map.extent.width, this.map.extent.height, null);

      if (0 !== e.dx || 0 !== e.dy) {
        var _this$map$extent$offs = this.map.extent.offset(e.dx, e.dy, null),
            _t = _this$map$extent$offs.center;

        this.map.goTo({
          center: _t,
          zoom: this.map.zoom
        }, {
          animate: !1
        });
      }
    }
  }, {
    key: "_removeAutoPanListeners",
    value: function _removeAutoPanListeners() {
      this.listeners.removeAll(), this._clearFlags(), clearInterval(this._timer), this._timer = null;
    }
  }, {
    key: "activate",
    value: function activate() {
      this._createAutoPanListeners();
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      return this._removeAutoPanListeners(), Promise.resolve();
    }
  }, {
    key: "setEditToolbar",
    value: function setEditToolbar(t) {
      var _this3 = this;

      this.editToolbar = t, this.editToolbar.on("update", function (t) {
        var e = t.toolEventInfo;
        if (!e || e && "reshape" !== e.type) return;

        var s = e.selected[0],
            i = _this3.map.toScreen(s.geometry);

        i.x < 0 || i.x > _this3.map.width || i.y < 0 || i.y > _this3.map.height || (_this3._checkMousePosition(i), _this3._interval(!0));
      });
    }
  }, {
    key: "setInsets",
    value: function setInsets(e) {
      var _this4 = this;

      this.insets = [].concat(_toConsumableArray(t.autoPan.insets), _toConsumableArray(e)), this.insets.forEach(function (t) {
        "*" === t.width && (t.width = _this4.map.width), "*" === t.height && (t.height = _this4.map.height);
      });
    }
  }]);

  return AutoPan;
}();

export { AutoPan as A, ListenerManager as L, e as P };